//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data: function data() {
    return {
      reconcile: {
        bank_account: {},
        system_account_balance: 0.00,
        bank_account_balance: 0.00,
        period: moment(),
        statement_date: moment().format("MM/DD/YYYY")
      },
      loading: true
    };
  },


  methods: {
    close: function close() {
      Event.$emit('close-full-modal');
    },
    markPending: function markPending() {
      axios.post('/prototype/accounting/general-ledger/reconcile/' + this.reconcile.id + '/mark-pending').then(function (response) {
        Event.$emit('close-full-modal');
        Event.$emit('refresh-bank-reconciles');
      });
    },
    getExplanatoryType: function getExplanatoryType(item) {
      if (item.accounting_type == 'debit') {
        return 'Deposit';
      }
      if (item.accounting_type == 'credit') {
        return 'Withdrawal';
      }
      if (item.accounting_type == 'adjustment-positive' || item.accounting_type == 'adjustment-negative') {
        return 'Adjustment';
      }
      return '';
    }
  },

  computed: {
    userCanReset: function userCanReset() {
      return window.user.role == 'super-admin' || window.user.id.includes('andrew@maderaresidential.com') || window.user.id.includes('krendon@maderaresidential.com');
    },
    totalChecks: function totalChecks() {
      var amount = 0;
      if (this.reconcile.outstandingChecks) {
        this.reconcile.outstandingChecks.map(function (item) {
          amount += parseFloat(item.amount);
        });
      }
      return amount;
    },
    totalCredits: function totalCredits() {
      var amount = 0;
      if (this.reconcile.outstandingCredits) {
        this.reconcile.outstandingCredits.map(function (item) {
          amount += parseFloat(item.amount);
        });
      }
      return amount;
    },
    totalDeposits: function totalDeposits() {
      var amount = 0;
      if (this.reconcile.outstandingDeposits) {
        this.reconcile.outstandingDeposits.map(function (item) {
          amount += parseFloat(item.amount);
        });
      }
      return amount;
    },
    totalDebits: function totalDebits() {
      var amount = 0;
      if (this.reconcile.outstandingDebits) {
        this.reconcile.outstandingDebits.map(function (item) {
          amount += parseFloat(item.amount);
        });
      }
      return amount;
    },
    totalBank: function totalBank() {
      var amount = 0;
      if (this.reconcile.outstandingBank) {
        this.reconcile.outstandingBank.map(function (item) {
          amount += parseFloat(item.amount);
        });
      }
      return amount;
    },
    totalOutstanding: function totalOutstanding() {
      return this.totalChecks + this.totalCredits - (this.totalDeposits + this.totalDebits) + this.totalBank;
    },
    totalDifference: function totalDifference() {
      return parseFloat(this.reconcile.bank_account_balance) - (parseFloat(this.totalOutstanding) + parseFloat(this.reconcile.system_account_balance));
    }
  },

  mounted: function mounted() {
    var _this = this;

    var $el = this;

    Event.$on('completed-bank-reconcile', function (id) {
      $el.$children[0].$data.showModal = true;
      _this.loading = true;
      axios.get('/prototype/accounting/general-ledger/reconcile/' + id + '/view-completed').then(function (response) {
        _this.reconcile = response.data;
        _this.loading = false;
      });
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/reconcile/CompletedReconcile.vue
// module id = IAR4
// module chunks = 0 1